import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-neutral-100 py-10 sm:py-16" data-id="element-87" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-88" data-mp="9ttiogmj291a">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center gap-6 rounded-3xl border-2 border-green-600 bg-white p-8 text-center shadow-lg sm:flex-row sm:text-left" data-id="element-89" data-mp="9wfpuf5iamiz">
          <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-full bg-green-600 text-white" data-id="element-90" data-mp="slvtvcgegx45">
            <ShieldCheckIcon className="h-12 w-12" data-id="element-91" data-mp="xjfj17emyuav" />
          </div>
          <div data-id="element-92" data-mp="12jtfds6vkft2">
            <h2 className="text-2xl font-black text-neutral-900 sm:text-3xl" data-id="element-93" data-mp="12kbjtc3oy0c2">
              Garantía de Hierro de 7 días
            </h2>
            <p className="mt-3 text-base leading-relaxed text-neutral-700" data-id="element-94" data-mp="17fqvpyi51m5u">
              Probá el sistema por 7 días. Si no lográs hacer la mejor milanesa de tu
              vida o sentís que las recetas no son para vos, te devuelvo el{' '}
              <span className="font-bold" data-id="element-95" data-mp="1vszeb2lpc47j">100% de tu dinero. Sin preguntas.</span> Y te
              quedás con el material por las molestias. Así de seguro estoy de que esto
              va a cambiar tu cocina.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}